"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillPreferencePanel = void 0;
var PaperLessBillDetailsPanelCms_cms_1 = require("../components/panels/PaperLessBillDetailsPanel/PaperLessBillDetailsPanelCms.cms");
var AutoPaymentDetailsPanelCms_cms_1 = require("../components/panels/AutoPaymentDetailsPanel/AutoPaymentDetailsPanelCms.cms");
var BillLanguagePanelCms_cms_1 = require("../components/panels/BillLanguagePanel/BillLanguagePanelCms.cms");
var BillPreferencesPanelCms_cms_1 = require("../components/panels/BillPreferencesPanel/BillPreferencesPanelCms.cms");
var BillPreferencePanel = /** @class */ (function () {
    function BillPreferencePanel() {
        this.panelContent = new BillPreferencesPanelCms_cms_1.BillPreferencesPanelCms();
        this.autoPaymentDetails = new AutoPaymentDetailsPanelCms_cms_1.AutoPaymentDetailsPanelCms();
        this.billLanguage = new BillLanguagePanelCms_cms_1.BillLanguagePanelCms();
        this.paperlessDetails = new PaperLessBillDetailsPanelCms_cms_1.PaperLessBillDetailsPanelCms();
    }
    return BillPreferencePanel;
}());
exports.BillPreferencePanel = BillPreferencePanel;
//# sourceMappingURL=BillPreferencePanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/BillPreferencePanel.cms.js
// module id = 2034
// module chunks = 8